import { render, staticRenderFns } from "./PowerBI.vue?vue&type=template&id=6f4f8d0a&scoped=true&"
import script from "./PowerBI.vue?vue&type=script&lang=js&"
export * from "./PowerBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4f8d0a",
  null
  
)

export default component.exports